import { Sidebar } from '@jablotron/lib.spa-components';
import { useTranslate } from '@jablotron/lib.spa-lang';
import { useParams, useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { buildSidebarCategories, type SidebarCategory } from './CatalogSidebar';
import { MobileCatalogNav } from './MobileCatalogNav';
import { MenuIcon } from '~/components/icons/MenuIcon';
import { getCatalog } from '~/entities/catalog/api';
import { Texts } from '~/texts/runtime';

/** Mobile site navigation (catalog, Compatibility, Blog) — available on every page via the site header. */
export function CatalogMobileMenu() {
  const t = useTranslate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [categories, setCategories] = useState<SidebarCategory[]>([]);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const search = useRouterState({ select: (s) => s.location.searchStr });
  const params = useParams({ strict: false }) as {
    categoryId?: string;
    subcategoryId?: string;
  };

  useEffect(() => {
    void getCatalog().then((catalog) => {
      setCategories(
        buildSidebarCategories(catalog, {
          activeSubcategoryId: params.subcategoryId,
        }),
      );
    });
  }, [params.subcategoryId]);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname, search]);

  return (
    <div className="lg:hidden">
      <Sidebar
        name="catalog-menu"
        open={menuOpen}
        onOpenChange={setMenuOpen}
        side="left"
        title={t(Texts.MobileMenuTitle)}
        showOverlay
        contentClassName="w-[min(20rem,calc(100vw-2rem))]"
        trigger={
          <button
            type="button"
            className="flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-lg border border-primary bg-white text-brand-ink"
            aria-label={t(Texts.MenuOpen)}
          >
            <MenuIcon />
          </button>
        }
      >
        <MobileCatalogNav
          // Remount once the catalog loads so the active line starts expanded.
          key={categories.length}
          categories={categories}
          activeCategoryId={params.categoryId}
          activeSubcategoryId={params.subcategoryId}
          onNavigate={() => setMenuOpen(false)}
        />
      </Sidebar>
    </div>
  );
}
